var $64f20e1112866bbd$exports = {};
$64f20e1112866bbd$exports = {
    "decrease": (args)=>`${args.fieldLabel} verringern`,
    "increase": (args)=>`${args.fieldLabel} erh\xf6hen`,
    "numberField": `Nummernfeld`
};


export {$64f20e1112866bbd$exports as default};
//# sourceMappingURL=de-DE.mjs.map
